import { useAuth } from "@clerk/react"
import { useQuery } from "@tanstack/react-query"
import { useMarketplaceOrpc } from "@/integrations/orpc"
import { moderationQueryKey } from "./use-moderation-cases"

export const moderationConfigQueryKey = [
	...moderationQueryKey,
	"config",
] as const

export function useModerationConfig({
	enabled = true,
}: {
	enabled?: boolean
} = {}) {
	const { client } = useMarketplaceOrpc()
	const { isSignedIn } = useAuth()

	const { data, isLoading, error, refetch } = useQuery({
		queryKey: moderationConfigQueryKey,
		queryFn: () => client.configuration.getModerationConfig(),
		enabled: enabled && !!isSignedIn,
	})

	return { configVersion: data ?? null, isLoading, error, refetch }
}
